import Button from './button';
export default Button;
export { ButtonProps } from './PropsType';
